import { render } from "./ObjectData.vue?vue&type=template&id=7d3d9176&scoped=true"
import script from "./ObjectData.vue?vue&type=script&lang=js"
export * from "./ObjectData.vue?vue&type=script&lang=js"

import "./ObjectData.vue?vue&type=style&index=0&id=7d3d9176&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7d3d9176"

export default script